import { skivy71 } from '../npm.org'

export default skivy71.utils.sys